import { Col, Row, Spin, Empty } from "antd";
import React from "react";
import ClientDetailsCard from "../components/clients/client-details-card/ClientDetailsCard";
import { useSelector } from "react-redux";
import {
  getClientOrganizationList,
  Organization,
} from "@src/redux";

const Clients: React.FC = () => {
  const {
    result: clientOrganizationList,
    loading: clientOrganizationListLoading,
  } = useSelector(getClientOrganizationList);

  return (
    <div>
      {clientOrganizationListLoading ? (
        <Row justify="center" align="middle" style={{ minHeight: "40vh" }}>
          <Col>
            <Spin size="default" />
          </Col>
        </Row>
      ) : (
        <div className="client-list-container">
          {(clientOrganizationList?.items?.length ?? 0) > 0 ? (
            clientOrganizationList?.items?.map((client: Organization) => (
              <ClientDetailsCard key={client.id} client={client} />
            ))
          ) : (
            <Row justify="center" align="middle" style={{ minHeight: "40vh" }}>
              <Col>
                <Empty description="No clients found" />
              </Col>
            </Row>
          )}
        </div>
      )}
    </div>
  );
};

export default Clients;
